import { render, staticRenderFns } from "./personPwd.vue?vue&type=template&id=c5afdbcc&scoped=true&"
import script from "./personPwd.vue?vue&type=script&lang=js&"
export * from "./personPwd.vue?vue&type=script&lang=js&"
import style0 from "./personPwd.vue?vue&type=style&index=0&id=c5afdbcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5afdbcc",
  null
  
)

export default component.exports